import powerPlug from 'assets/img/power-plug.svg';
import Button from 'components/Button';
import Icon from 'components/Icon';
import { i18nPath } from 'config/i18nNs';
import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import type { RootState } from 'store/reducers';
import { Heading1 } from 'typography';
import { sendDatacatError } from 'utils/log';
import { projectId } from 'utils/urlQueries';
import { getPathInfo, isExcom } from 'utils/versionUtils';
import styles from './notFound.module.scss';

const NotFound = ({ missingContent }: { missingContent: boolean }) => {
  const { t } = useTranslation();
  const validProject = useSelector(
    (state: RootState) => state.data.validProject
  );
  const currentUrl = `${window.location.href}${window.location.search}`;

  useEffect(() => {
    if (!missingContent && validProject) {
      sendDatacatError({
        url: currentUrl,
        error: 'page not found',
        type: 'page not found'
      });
    }
  }, [missingContent]);

  const { polVersion } = getPathInfo();

  const history = useHistory();

  const backToHome = () => {
    polVersion === 'employees'
      ? isExcom(projectId)
        ? history.push('/employees/home-excom')
        : history.push('/employees/home')
      : (window.location.href =
          'https://www.carlsberggroup.com/who-we-are/about-the-carlsberg-group/global-presence/');
  };

  return (
    <>
      <div className={styles.root}>
        <img height={'118px'} src={powerPlug} alt="Error image" />
        <Heading1>
          <div className="uppercase">
            <Trans
              i18nKey={`${i18nPath.master}.pages.errorNotFoundpage.view.title`}
              components={{
                break: <span className="break" />
              }}
            />
          </div>
        </Heading1>
        <p className={styles.desc}>
          {t(`${i18nPath.master}.pages.errorNotFoundpage.view.description`)}
        </p>
        <div className={styles.button}>
          <Button color={'#284A41'} onClick={backToHome}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Icon name="icon-diagonal-up-left" size={24} />
              {t(
                `${i18nPath.master}.pages.errorNotFoundpage.view.calltoAction`
              )}
            </div>
          </Button>
        </div>
      </div>
    </>
  );
};

export default NotFound;
